<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {},
  created() {
    // window.addEventListener('beforeunload',() => {
    //   if(this.$store.state.tagsView.cachedViews) {
    //     localStorage.setItem('cachedComponent',this.$store.state.tagsView.cachedViews)
    //   }
    // })
    // window.addEventListener('load',() => {
      // this.$store.dispatch('addVisitedTag',this.$store.state.tagsView.visitedViews)
      // this.$store.state.tagsView.cachedViews.push('information')
      // console.log(this.$store.state.tagsView)
    // })
  }
}
</script>

<style>
/*表格滚动条设置为10px*/
.el-table__header-wrapper{
    width: calc(100% - 10px);
}
.el-table__fixed-right-patch,
.el-table__fixed-left-patch{
    width: 10px!important;
}
.el-table__fixed-header-wrapper{
    height: 56px!important;
}
.el-table__fixed-body-wrapper{
    height: calc(100% - 56px)!important;
}
.el-table__body-wrapper{
    overflow-y: scroll !important;
}
.el-table__body-wrapper::-webkit-scrollbar{
    width: 10px;
    height: 10px;
}
.el-table__fixed-right,
.el-table__fixed-left,
.el-table__fixed{
    //right: 10px!important;
    height: calc(100% - 10px)!important; /*前提是表格高度设置500*/
}


/*.el-table td {
  background: #F8FAFA;
}
.el-table--striped .el-table__body tr.el-table__row--striped td{
      background: #FFFFFF;
}*/

.el-table tbody tr:nth-child(odd) td{
  background: #F8FAFA;
}
.el-table tbody tr:nth-child(even) td{
  background: #FFFFFF;
}
.el-table--striped .el-table__body tr.el-table__row--striped td{
      background: #FFFFFF;
}
.el-table tbody tr:nth-child(odd):hover td{
  background-color:rgb(236, 248, 243);
}
.el-table tbody tr:nth-child(even):hover td{
   background-color:rgb(236, 248, 243);
}

.el-table__body tr.hover-row:nth-child(odd)>td{
  background-color:rgb(236, 248, 243);
}
.el-table tbody tr.hover-row:nth-child(even) td{
  background: rgb(236, 248, 243);
}
.el-table--striped .el-table__body tr.el-table__row--striped.hover-row td{
  background: rgb(236, 248, 243);
}



#pagination{
  position: absolute;
  bottom: 20px;
}
.main>div{
  height: 100%;
}

form.el-form {
    width:100% !important;
}
.el-tabs__nav-scroll {
    padding: 0px !important;
}

.el-date-range-picker__time-picker-wrap .el-time-panel{
  display: none!important;
}
.is-error /deep/ .el-upload--picture-card{
  border-color: #f56c6c;
}
.is-error /deep/ .el-upload--picture-card i{
  color: #f56c6c;
}
</style>
